import { connect } from 'react-redux';

import Actions from '../../actions';
import MunicipalityAPI from '../../apis/municipality';
import TaxonAPI from '../../apis/taxons';
import ZoneAPI from '../../apis/zones';
import localStorageAPI from '../../services/local-storage-api';

const mapStateToProps = (state, ownProps) => ({
    taxons: state.taxons,
    user: state.user,
    navigation: state.navigation,
    locale: state.locale,
    order: state.order,
    currentStore: state.stores.currentStore,
    currentZone: state.zones.currentZone,
    availableZones: state.zones.availableZones,
    stores: state.stores.stores,
    storesByZone: state.stores.storesByZone,
    pageCount: state.stores.pageCount,
    displayLoader: state.displayLoader,
});

const mapDispatchToProps = (dispatch) => ({
    // TODO: Remover este filtro y traer por default de la api solo el filter[roots]=1
    rootTaxon: (taxons) => taxons.filter((taxon) => taxon.attributes.permalink === 'mercado-unico')[0],

    triggerInitialSetup: async (locale, currentStore, order) => {
        let zones = [];
        await ZoneAPI.getZones()
            .then((response) => {
                zones = response.body.zones;
            });

        dispatch(Actions.setAvailableZones(zones));

        const municipalities = await MunicipalityAPI.getMunicipalities();
        dispatch(Actions.setAvailableMunicipalities(municipalities));

        const response = await dispatch(Actions.fetchStores());
        const store = response.find((store) => ((currentStore) ? store.id === currentStore.id : store.id === 1));
        if (store) {
            currentStore = store;
        } else {
            // eslint-disable-next-line prefer-destructuring
            currentStore = response[0];
        }
        if (order.id && order.store && Object.prototype.hasOwnProperty.call(order.store, 'id') && response.findIndex((store) => store.id === order.store.id) === -1) {
            dispatch(Actions.emptyCart(order, locale)).then(() => {
            }, (error) => {
                console.log(error);
            });
        }
        const taxonsMenu = [];
        const fetchedTaxons = await TaxonAPI.getTaxons(currentStore.id);
        const taxonRoot = fetchedTaxons.filter((taxon) => taxon.parent_id === null)[0];
        const taxonsCategory = fetchedTaxons.filter((taxon) => taxon.parent_id === taxonRoot.id);
        const taxonCategorySubcategory = taxonsCategory
            .map((taxonCategory) => ({
                taxonCategory,
                taxons: fetchedTaxons.filter((taxon) => taxon.parent_id === taxonCategory.id),
            }));
        taxonsMenu.push({ store: currentStore, taxonRoot, taxons: [...taxonCategorySubcategory] });

        dispatch(Actions.addTaxons({ taxonsMenu, fetchedTaxons }));
    },
});

export default connect(mapStateToProps, mapDispatchToProps);



/** WEBPACK FOOTER **
 ** ./src/containers/base/base-menu.js
 **/